// Copyright (C) 2017-2023 Smart code 203358507

if (typeof process.env.SENTRY_DSN === 'string') {
    const Sentry = require('@sentry/browser');
    Sentry.init({ dsn: process.env.SENTRY_DSN });
}

if (typeof window !== 'undefined') {
    const isSuppressedMediaError = (errorOrMessage) => {
        const message = typeof errorOrMessage === 'string'
            ? errorOrMessage
            : (errorOrMessage?.message || '');
        const name = errorOrMessage?.name || '';
        return (
            name === 'AbortError' ||
            errorOrMessage?.code === 20 ||
            /fetching process for the media resource was aborted/i.test(message) ||
            /play\(\) request was interrupted/i.test(message)
        );
    };

    window.addEventListener('error', (event) => {
        if (isSuppressedMediaError(event.error) || isSuppressedMediaError(event.message)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);

    window.addEventListener('unhandledrejection', (event) => {
        if (isSuppressedMediaError(event.reason)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }, true);
}

const React = require('react');
const ReactDOM = require('react-dom/client');
const { HashRouter } = require('react-router-dom');
const i18n = require('i18next');
const { initReactI18next } = require('react-i18next');
const stremioTranslations = require('stremio-translations');
const App = require('./App');
const { default: WebUpdateScreen } = require('./App/WebUpdateScreen');
const { CoreProvider } = require('./core');
const { FileDropProvider, PlatformProvider } = require('./common');
const Landing = require('./landing/Landing');
const nextEntryState = require('./landing/entryState');

const translations = Object.fromEntries(Object.entries(stremioTranslations()).map(([key, value]) => [key, {
    translation: { ...value, ...require('./caroline/i18n/presentationStrings')[key] }
}]));

i18n
    .use(initReactI18next)
    .init({
        resources: translations,
        lng: 'pt-PT',
        fallbackLng: 'en-US',
        interpolation: {
            escapeValue: false
        }
    });

const appInfo = {
    appVersion: process.env.VERSION,
    shellVersion: null
};

const root = ReactDOM.createRoot(document.getElementById('app'));
const Entry = () => {
    const [entry, setEntry] = React.useState(() => nextEntryState(null, window.location));
    React.useEffect(() => {
        const updateEntry = () => setEntry((previous) => nextEntryState(previous, window.location));
        window.addEventListener('hashchange', updateEntry);
        window.addEventListener('popstate', updateEntry);
        return () => {
            window.removeEventListener('hashchange', updateEntry);
            window.removeEventListener('popstate', updateEntry);
        };
    }, []);

    return (
        <>
            {entry.landing && <Landing />}
            {/* Core's existing transport is initialized once per document.
                Keep that instance across marketing back/forward navigation. */}
            {entry.hasEntered && <div hidden={entry.landing} style={{ display: entry.landing ? 'none' : undefined, width: '100%', height: '100%' }}>
                <PlatformProvider>
                    <CoreProvider appInfo={appInfo}>
                        <FileDropProvider>
                            <HashRouter>
                                <>
                                    <WebUpdateScreen />
                                    <App />
                                </>
                            </HashRouter>
                        </FileDropProvider>
                    </CoreProvider>
                </PlatformProvider>
            </div>}
        </>
    );
};

root.render(
    <React.StrictMode>
        <Entry />
    </React.StrictMode>
);
